import { spawn } from 'redux-saga/effects';

import { sagas as issuejwtSagas } from './issuejwtModule';
import twoFactorSagas from './twoFactor/twoFactorSagas';

export default function* sagas() {
	yield spawn(issuejwtSagas);
	yield spawn(twoFactorSagas);
}
